/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

//import translation function for language translation
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";

import BreadCrumb from "../BreadCrumb/BreadCrumb";
import AlertNotification from "../AlertNotification/AlertNotification";
import SuccessProcessModal from "../Modal/SuccessProcessModal";
import ProcessModuleOptions from "data/Prod/ProcessModuleOptions.json";
import { reactSelectStyle } from "Config/Config";
import { reorder } from "helper/Common/CommonHelper";

const ActivityProcessForm = ({
  afterModalClose,
  breadcrumbText,
  isTemplate = false,
  moduleName = "",
  moduleslug = "",
}) => {
  const params = useParams();
  const token = localStorage.getItem("token");
  const { t } = useTranslation(); //for translation
  const [followersInput, setFollowersInput] = useState("");
  const [folowersOptions, setFollowersOptions] = useState([]);

  const [tagList, setTagList] = useState([]);

  const [title, settitle] = useState("");
  const [slug, setslug] = useState("");
  const [details, setdetails] = useState("");
  const [tagValue, settagValue] = useState(null);
  const [selectedTags, setselectedTags] = useState([]);
  const [followersValue, setfollowersValue] = useState(null);
  const [selectedFollowers, setselectedFollowers] = useState([]);
  const [moduleValue, setmoduleValue] = useState(null);
  const [selectedModule, setSelectedModule] = useState("");
  const [isProcessOwner, setisProcessOwner] = useState(false);

  // Validation state from SaveChapterPopup
  const [errors, setErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // Validation function from SaveChapterPopup
  const validateForm = () => {
    const newErrors = {};

    if (!title.trim()) {
      newErrors.title = t("Process Name is required");
    }
    if (!slug.trim()) {
      newErrors.slug = t("Slug is required");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get followers input
  const followersInputHandler = (val) => {
    setFollowersInput(val);
  };

  //function for get all tags
  const getAllTags = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_TAGS +
        `?modulename=${moduleName}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        setTagList(response.data);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //function for get followers list
  const getFollowersList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `?userstringinput=${followersInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        if (response.data.length > 0) {
          setFollowersOptions(response.data);
        }
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //select tags
  const tagSelectionHandler = (val) => {
    if (val) {
      settagValue(val);
      setselectedTags(
        val.map((item) => ({
          tagid: item.value,
          componentorderid: item?.componentorderid ?? null,
        }))
      );
    } else {
      settagValue(null);
      setselectedTags([]);
    }
  };

  // Handle drag-and-drop end
  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedTags = reorder(
      tagValue,
      result.source.index,
      result.destination.index
    );
    settagValue(reorderedTags);
    setselectedTags(
      reorderedTags.map((item) => ({
        tagid: item.value,
        componentorderid: item?.componentorderid ?? null,
      }))
    );
  };

  //select followers
  const followersSelectionHandler = (val) => {
    setfollowersValue(val);
    setselectedFollowers(val.map((item) => item.value));
  };

  //select module
  const moduleSelectionHandler = (val) => {
    if (val) {
      setmoduleValue(val);
      setSelectedModule(val.value);
    } else {
      setmoduleValue(null);
      setSelectedModule("");
    }
  };

  //get process details
  const getProcessDetails = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_PROCESS_DETAILS +
        `/${params.id}`;

      const response = await getData(requestURL);

      console.log(response);

      if (response.status && response.data) {
        settitle(response.data.title);
        setslug(response.data.slug);
        setdetails(response.data?.description ?? "");
        if (response.data.tagvalues.length > 0) {
          tagSelectionHandler(response.data.tagvalues);
        }

        if (response.data.followersArr) {
          followersSelectionHandler(response.data.followersArr);
        }

        for (let moduleData of ProcessModuleOptions) {
          if (moduleData.value === response.data.moduleslug) {
            moduleSelectionHandler(moduleData);
          }
        }

        if (moduleName === "administration") {
          setisProcessOwner(true);
        } else {
          setisProcessOwner(response.data.isuserprocessowner);
        }
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //save process
  const saveProcessHandler = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      setIsSaving(true);

      let processData = {
        title,
        slug: slug.toUpperCase(),
        description: details,
        moduleslug: moduleslug === "" ? selectedModule : moduleslug,
        istemplate: isTemplate,
        tags: selectedTags,
        followers: selectedFollowers,
        status: "1",
      };

      let requestURL = url.API_BASE_URL;

      let response = {};

      if (params.id) {
        requestURL += url.API_UPDATE_PROCESS + `/${params.id}`;

        response = await putData(requestURL, processData);

        console.log("response of process update", response);
      } else {
        requestURL += url.API_ADD_NEW_PROCESS;

        response = await postData(requestURL, processData);
      }

      setIsSaving(false);

      if (response.status) {
        setMessageType("success");
        resetHandler();

        setTimeout(() => {
          const bootstrapModal = new bootstrap.Modal(
            document.getElementById("afterSaveProcessModal")
          );

          bootstrapModal.show();
        }, 1500);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
      setShowAlert(true);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  const resetHandler = () => {
    setFollowersInput("");
    setFollowersOptions([]);
    settitle("");
    setslug("");
    setdetails("");
    settagValue(null);
    setselectedTags([]);
    setfollowersValue(null);
    setselectedFollowers([]);
    setmoduleValue(null);
    setSelectedModule("");
    setErrors({});
  };

  useEffect(() => {
    if (params.id) {
      getProcessDetails();
    }
  }, [params.id]);

  useEffect(() => {
    getAllTags();
  }, []);

  useEffect(() => {
    if (followersInput.length > 0) {
      getFollowersList();
    }
  }, [followersInput]);

  const followersOptionsToShow =
    folowersOptions.length > 0 ? folowersOptions : [];

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  return (
    <div className="container-fluid px-lg-5">
      <BreadCrumb breadCrumbText={breadcrumbText} />
      <div className="create-lead-container p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm mt-2">
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="fields-container flex-fill">
            {/* Validation JSX for Process Name (title) */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label htmlFor="title" className="d-block fs-sm fw-semibold mb-2">
                {t("Process Name")}
              </label>
              <input
                type="text"
                className={`form-control fs-sm shadow-none ${
                  errors.title ? "is-invalid" : "border border-gray-300"
                }`}
                placeholder={t("Enter a descriptive process name")}
                value={title}
                onChange={(e) => {
                  settitle(e.target.value);
                  if (errors.title) {
                    setErrors((prev) => ({ ...prev, title: "" }));
                  }
                }}
              />
              {errors.title && (
                <div className="invalid-feedback">{errors.title}</div>
              )}
            </div>

            {/* Validation JSX for Slug */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label
                htmlFor="slugID"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Slug")}
              </label>
              <input
                type="text"
                id="slug"
                className={`form-control fs-sm shadow-none ${
                  errors.slug ? "is-invalid" : "border border-gray-300"
                }`}
                placeholder={t("e.g., NEW-CLIENT-ONBOARDING")}
                value={slug}
                onChange={(e) => {
                  setslug(e.target.value);
                  if (errors.slug) {
                    setErrors((prev) => ({ ...prev, slug: "" }));
                  }
                }}
              />
              {errors.slug && (
                <div className="invalid-feedback">{errors.slug}</div>
              )}
            </div>

            {/* <!-- ========== Start details Section ========== --> */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label
                htmlFor="slugID"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Details")}
              </label>
              <textarea
                name="details"
                id="details"
                cols="30"
                rows="6"
                className="form-control border border-gray-300 shadow-none"
                placeholder={t("Enter a detailed description of the process")}
                value={details}
                onChange={(e) => setdetails(e.target.value)}
              ></textarea>
            </div>
            {/* <!-- ========== End details Section ========== --> */}

            {/* tags */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label
                htmlFor="slugID"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Labels")}
              </label>
              <Select
                isMulti
                styles={reactSelectStyle("3px", "6px", true, false)}
                placeholder={t("Select or search for relevant labels")}
                options={tagList}
                value={tagValue}
                onChange={(val) => {
                  tagSelectionHandler(val);
                }}
              />
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="tags">
                  {(provided) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={{ marginTop: "10px" }}
                    >
                      {tagValue?.map((tag, index) => (
                        <Draggable
                          key={tag.value}
                          draggableId={tag.value.toString()}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                padding: "8px",
                                marginBottom: "4px",
                                backgroundColor: "#f1f1f1",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                ...provided.draggableProps.style,
                              }}
                            >
                              <span>{tag.label}</span>
                              <span
                                style={{
                                  cursor: "grab",
                                  fontSize: "16px",
                                  color: "#888",
                                }}
                              >
                                ☰
                              </span>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>

            {/* <!-- ========== Start followers Section ========== --> */}
            {moduleName === "administration" ? null : (
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="slugID"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Followers")}
                </label>
                <Select
                  isMulti
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  placeholder={t(
                    "Search by user name or email to add followers"
                  )}
                  options={followersOptionsToShow}
                  value={followersValue}
                  onChange={(val) => followersSelectionHandler(val)}
                  onInputChange={(val) => {
                    followersInputHandler(val);
                  }}
                />
              </div>
            )}
            {/* <!-- ========== End followers Section ========== --> */}

            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label
                htmlFor="slugID"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Select Module")}
              </label>
              <Select
                isClearable
                styles={reactSelectStyle("3px", "6px", true, false)}
                placeholder={t("Choose the module this process belongs to")}
                options={ProcessModuleOptions}
                value={moduleValue}
                onChange={(val) => moduleSelectionHandler(val)}
              />
            </div>
            {/* <!-- ========== End module select Section ========== --> */}
          </div>

          <div className="action d-flex justify-content-between gap-3 py-4 mt-auto">
            <div className="d-flex align-items-center gap-2">
              <Link
                to={
                  moduleName === "administration"
                    ? "/admin/administration/activityprocess/list"
                    : `/admin/crm/process/list`
                }
                className="btn btn-outline-primary d-flex align-items-center gap-2"
                aria-label="Close"
              >
                <span className="material-symbols-outlined me-1">cancel</span>
                {t("Close")}
              </Link>
            </div>
            {params.id ? (
              isProcessOwner ? (
                <button
                  onClick={saveProcessHandler}
                  type="button"
                  className="btn btn-primary d-flex align-items-center gap-2"
                  disabled={isSaving}
                  style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                >
                  {isSaving ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {t("Saving...")}
                    </>
                  ) : (
                    <>
                      <span className="material-symbols-outlined me-1">
                        save
                      </span>{" "}
                      {t("Save")}
                    </>
                  )}
                </button>
              ) : null
            ) : (
              <button
                onClick={saveProcessHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Process")}
                  </>
                )}
              </button>
            )}
          </div>
        </form>
      </div>

      <SuccessProcessModal
        afterSaveModalClose={afterModalClose}
        moduleName={moduleName}
      />

      {showAlert && (
        <AlertNotification
          showAlert={showAlert}
          message={alertMessage}
          alertType={messageType}
          onClose={onAlertClose}
        />
      )}
    </div>
  );
};

export default ActivityProcessForm;
